const FAKE_CHAPTER_IDS = ["4", "7", "8", "9", "10", "13", "14", "15", "513"];

export function rewriteUrl(url, host, isServer = false) {
  try {
    const isDev = process.env.NODE_ENV === "development";
    const suitableHost = isServer ? host : window.location.host;
    const origin = isDev ? `http://localhost:8080` : `https://${suitableHost}`;

    if (!origin.includes('stepstochrist.pub') && !origin.includes('localhost') && !origin.includes('sc.alpha.egwhite.net')) return url;

    const u = new URL(url);
    if (u.pathname.startsWith("/content/books/108")) {
      if (u.pathname === "/content/books/108/toc") {
        u.pathname = "/api/fake/content/books/108/toc";

        console.log("Rewriting URL:", url);
        return origin + u.pathname + u.search;
      }

      if (u.pathname === "/content/books/108/tracklist") {
        u.pathname = "/api/fake/content/books/108/tracklist";

        console.log("Rewriting URL:", url);
        return origin + u.pathname + u.search;
      }

      const chapterMatch = u.pathname.match(
        /^\/content\/books\/108\/chapter\/(\d+)(\?trans=all)?$/
      );
      if (chapterMatch && FAKE_CHAPTER_IDS.includes(chapterMatch[1])) {
        u.pathname = `/api/fake/content/books/108/chapter/${chapterMatch[1]}`;

        console.log("Rewriting URL:", url);
        return origin + u.pathname + u.search;
      }
    }
  } catch(e) {
    // If URL parsing fails, return the original URL
    console.error("Invalid URL:", url, e);
    return url;
  }
  return url;
}
